import type { IApiConfig, TApiName } from "./types";

export const API_CONFIG: Record<TApiName, IApiConfig> = {
  audioTranscription: {
    envUrl: "REACT_APP_AUDIO_TRANSCRIPTION_URL",
  },
  aiScoring: { envUrl: "REACT_APP_AI_SCORING_URL" },
  baseUrl: { envUrl: "REACT_APP_BASE_URL" },
  bot: { envUrl: "REACT_APP_BOT_URL" },
  classificator: { envUrl: "REACT_APP_CLASSICATOR_TOOLS_URL" },
  deepsearch: { envUrl: "REACT_APP_DEEPSEARCH_AGENT_URL" },
  deerflow: { envUrl: "REACT_APP_DEERFLOW_AUTH_URL" },
  generatePrompt: { envUrl: "REACT_APP_GENERATE_PROMPT_URL" },
  model: { envUrl: "REACT_APP_THREAD_MODELS" },
  response: { envUrl: "REACT_APP_RESPONSE_API_URL" },
  skills: { envUrl: "REACT_APP_SKILLS_URL" },
  staticKey: { envUrl: "REACT_APP_STATIC_KEY_BASE_URL" },
  storage: { envUrl: "REACT_APP_STORAGE_BASE_URL" },
  thread: { envUrl: "REACT_APP_THREAD_URL" },
  telegram: { envUrl: "REACT_APP_TELEGRAM_API_URL" },
  vectorstores: { envUrl: "REACT_APP_VECTOR_STORES_LOCAL_URL" },
  vectorTools: { envUrl: "REACT_APP_VECTOR_TOOLS_URL" },
};
